"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

var _reactComponents = require("@cimpress/react-components");

var FulfillmentConfigurationErrorPage = function FulfillmentConfigurationErrorPage(_ref) {
  var loadFulfillmentConfigurations = _ref.loadFulfillmentConfigurations,
      errorMessage = _ref.errorMessage,
      errorStyle = _ref.errorStyle,
      showReload = _ref.showReload;

  var _useTranslation = (0, _reactI18next.useTranslation)('fulfillmentConfigurationErrorPage'),
      t = _useTranslation.t;

  var noAvailableFulfillmentConfigurationsPage = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "fcp-fulfillmentConfigurationErrorPage__title"
  }, t('noAvailableFulfillmentConfigurations.titleText')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPage__appLinks"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPageAppLinks__link"
  }, /*#__PURE__*/_react["default"].createElement(_reactStreamlineIcons.IconCheck, {
    className: "fcp-fulfillmentConfigurationErrorPageAppLinksLink__Icon"
  }), t('noAvailableFulfillmentConfigurations.productAssociationsSuggestion'), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://fcassociation.cimpress.io/",
    target: "_blank",
    rel: "noreferrer"
  }, t('noAvailableFulfillmentConfigurations.productAssociationsLink'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPageAppLinks__link"
  }, /*#__PURE__*/_react["default"].createElement(_reactStreamlineIcons.IconCheck, {
    className: "fcp-fulfillmentConfigurationErrorPageAppLinksLink__Icon"
  }), t('noAvailableFulfillmentConfigurations.fulfillmentConfigurationsSuggestion'), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://fulfillmentconfigurations.cimpress.io/",
    target: "_blank",
    rel: "noreferrer"
  }, t('noAvailableFulfillmentConfigurations.fulfillmentConfigurationsLink')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPage__emailLink"
  }, t('noAvailableFulfillmentConfigurations.emailSuggestion'), /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:platformsupport@cimpress.com"
  }, t('noAvailableFulfillmentConfigurations.emailLink'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPage__tryAgainText"
  }, t('noAvailableFulfillmentConfigurations.tryAgainText')));

  var errorLoadingFulfillmentConfigurationsPage = /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPage__alert"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
    status: errorStyle,
    dismissible: false,
    title: t('error.errorTitle'),
    message: errorMessage
  }));

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, errorMessage ? errorLoadingFulfillmentConfigurationsPage : noAvailableFulfillmentConfigurationsPage, showReload ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "fcp-fulfillmentConfigurationErrorPage__reloadButton"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    variant: "primary",
    onClick: function onClick() {
      return loadFulfillmentConfigurations();
    }
  }, t('reloadButtonText'))) : null);
};

FulfillmentConfigurationErrorPage.propTypes = {
  loadFulfillmentConfigurations: _propTypes["default"].func.isRequired,
  errorMessage: _propTypes["default"].string,
  errorStyle: _propTypes["default"].string,
  showReload: _propTypes["default"].bool
};
FulfillmentConfigurationErrorPage.defaultProps = {
  errorMessage: undefined,
  errorStyle: 'danger',
  showReload: true
};
var _default = FulfillmentConfigurationErrorPage;
exports["default"] = _default;